<template lang="html">
  <v-container v-bind:class="{ 'schedule-box ma-2': true, 'done': value.status === 2, 'canceled': value.status === 1, 'scheduled': value.status === 0, 'outDated':value.status === 5 }">
    <v-layout row wrap class="schedule-box-title">
      <v-flex xs10 pt-2 mt-2 class="schedule-conodminium-name">
        <span>{{ value.condominium.name }}</span>
      </v-flex>
      <v-flex pa-0 style="position:relative;">
        <div class="control-number"  @click="selectSchedule(value.id)">
          {{ value.controlNumber }}
        </div>
      </v-flex>
    </v-layout>
    <v-layout pa-2 row wrap>
      <v-flex xs12 class="schedule-conodminium-name">
        <div class="ellipsis">
          {{ value.condominium.address }}, {{ value.condominium.addressNumber }} - {{ value.condominium.neighborhood }}, {{ value.condominium.city }} - {{ value.condominium.state }}, {{ value.condominium.zipCode }}
        </div>
        <div class="">
          Administradora: {{ value.condominium.administrator }}
        </div>
        <div class="">
          <strong>
            Agendamento: <span v-if="value.dates.length > 1">Inicio: {{ value.dates[0] | formatDate }} Fim: {{ value.dates[value.dates.length - 1] | formatDate }}</span><span v-else> {{ value.dates[0] | formatDate }} </span>
          </strong>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="schedule-footer">
      <v-flex pt-0 pb-0 md2>
        <v-btn disabled flat icon>
          <v-icon>home</v-icon>
          {{ value.unitCount }}
        </v-btn>
      </v-flex>
      <v-flex pt-0 pb-0 md2>
        <v-btn disabled flat icon>
          <v-icon>email</v-icon>
          {{ value.sent ? value.condominiumsCount + value.sindicatesCount : "0"}}
        </v-btn>
      </v-flex>
      <v-flex pt-0 pb-0 md2>
        <v-btn :disabled="hasOrders" @click.native="showOrders(value.id)" flat icon color="deep-purple lighten-1">
          <v-icon>room_service</v-icon>
          {{ value.ordersCount }}
        </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex pt-0 pb-0 class="text-xs-right" md6>
        <v-btn class="mr-0" flat color="red lighten-1" @click="selectSchedule(value.id)">
          + Detalhes
        </v-btn>
      </v-flex>

      <!-- <v-flex class="text-xs-right">
        <v-btn flat  ma-0 color="red" @click="selectSchedule(value.id)">+ detalhes</v-btn>
      </v-flex> -->
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
export default {
  name: 'schedule',
  props: ['value'],
  methods: {
    showOrders (id) {
      this.$store.dispatch('showOrders', id)
    },
    selectSchedule (id) {
      this.$store.dispatch('selectSchedule', id)
    }
  },
  computed: {
    hasOrders () {
      return this.value.ordersCount === 0
    },
    outDated () {
      return moment().subtract(1, 'days').diff(moment(this.value.dates[0])) < 0 && this.value.status === 0
    }
  },
  filters: {
    formatDate (value) {
      return !value ? '' : moment(value).format('DD/MM/YYYY')
    }
  }
}
</script>

<style lang="css">
.canceled{
  border-color: red;
}
.done{
  border-color: green;
}
.schedule-box{
  position: relative;
  padding: 10px;
  border: 1px solid #cdcdcd;
  border-radius: 5px;
}
.schedule-details,.badge,.show-details{
  cursor: pointer;
}
.schedule-conodminium-name, .schedule-conodminium-address{
  white-space: nowrap;
  width: 100%;
  padding-right: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.canceled{
  border-color: red;
}
.done{
  border-color: green;
}
.schedule-title{
  font-size: 18px;
  color: #5a5a5a;
  font-weight: 600;
}
.outDated {
  border-color: #fe5200;
}
.scheduled{
  border-color: #e0dedc;
}
.schedule-box-title{
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid rgba(136, 136, 136, 0.2);
}
.schedule-footer{
  border-top: 1px solid rgba(136, 136, 136, 0.2);
}
.ellipsis{
  text-overflow: ellipsis;
  overflow: hidden;
}
.control-number{
  position: absolute;
  top: 2px;
  right: 2px;
  border-top-right-radius: 3px;
  background: #e3e3e3;
  color: #848484;
  bottom: 0px;
  padding: 13px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Schedule.vue?2192b4de